import {
  FILE_SET_UPLOAD_STATUS,
  FILE_SET_UPLOAD_STATUS_MESSAGE,
  FILE_SET_UPLOAD_SHOW_OFF,
  FILE_SET_UPLOAD_FILES,
  OS_FILTER_SHOW_OFF,
  FILE_SET_FILES_SENT_STATUS,
  FILE_SET_DUPLICATED_ORDERS,
  FILE_CLEAR_DUPLICATED_ORDERS,
  FILE_SET_UPLOAD_MAINTENANCE_STATUS,
  FILE_SET_UPLOAD_MODAL_ERROR,
  FILE_SET_UPLOAD_MAINTENANCE_MESSAGE
} from '../types'
import analytics from '@/api/analytics'
import notify from '@/api/notification'
import uploadService from '@/api/uploadFile'
import router from '../../router'
import { ORDER_STATE_FAIL, ORDER_STATE_PENDING_TRANSMISSION } from '@/enums'
import Moment from 'moment'
import { getCookie } from '@/utils/auth-utils'

const SUCESS_SAVED = 'A ordem de serviço foi atualizada com sucesso.'
const ERROR_SAVED = 'Não foi possível salvar essa operação.'

const state = {
  uploadFileStatus: 'STATUS_INITIAL',
  uploadFileStatusMessage: null,
  uploadFileMaintenanceStatus: 'STATUS_INITIAL',
  uploadFileMaintenanceMessage: null,
  filesFileSentStatus: 'STATUS_INITIAL',
  isUploadFileModalVisible: false,
  isUploadFileModalErrorVisible: false,
  duplicatedOrders: [],
  files: []
}

const mutations = {
  [FILE_SET_UPLOAD_STATUS](state, uploadFileStatus) {
    state.uploadFileStatus = uploadFileStatus
  },
  [FILE_SET_UPLOAD_STATUS_MESSAGE](state, uploadFileStatusMessage) {
    if (uploadFileStatusMessage === 'UPLOAD_ORDER_STATE_FAILED') {
      state.uploadFileStatusMessage = 'Falha ao submeter pedido para fila de validação'
    } else {
      state.uploadFileStatusMessage = uploadFileStatusMessage
    }

    if (uploadFileStatusMessage) {
      analytics.pushAnalyticsEvent('error-validation', {
        'msg-error': uploadFileStatusMessage
      })
    }
  },
  [FILE_SET_UPLOAD_SHOW_OFF](state, value) {
    state.isUploadFileModalVisible = value
  },
  [FILE_SET_UPLOAD_MODAL_ERROR](state, value) {
    state.isUploadFileModalErrorVisible = value
  },
  [FILE_SET_DUPLICATED_ORDERS](state, value) {
    state.duplicatedOrders = value
  },
  [FILE_CLEAR_DUPLICATED_ORDERS](state) {
    state.duplicatedOrders = []
  },
  [FILE_SET_UPLOAD_FILES](state, value) {
    state.files = value
  },
  [FILE_SET_FILES_SENT_STATUS](state, value) {
    state.filesFileSentStatus = value
  },
  [FILE_SET_UPLOAD_MAINTENANCE_STATUS](state, value) {
    state.uploadFileMaintenanceStatus = value
  },
  [FILE_SET_UPLOAD_MAINTENANCE_MESSAGE](state, value) {
    state.uploadFileMaintenanceMessage = value
  }
}

const getters = {
  uploadFileStatus: state => {
    return state.uploadFileStatus
  },
  uploadFileStatusMessage: state => {
    return state.uploadFileStatusMessage
  },
  isUploadFileModalVisible: state => {
    return state.isUploadFileModalVisible
  },
  duplicatedOrdersFromFile: state => {
    return state.duplicatedOrders
  },
  filesFileUploaded: state => {
    return state.files
  },
  filesFileSentStatus: state => {
    return state.filesFileSentStatus
  },
  uploadFileMaintenanceStatus: state => {
    return state.uploadFileMaintenanceStatus
  },
  uploadFileMaintenanceMessage: state => {
    return state.uploadFileMaintenanceMessage
  },
  isUploadFileModalErrorVisible: state => {
    return state.isUploadFileModalErrorVisible
  }
}

const actions = {
  setIsUploadFileModalError({ commit }, status) {
    commit('FILE_SET_UPLOAD_MODAL_ERROR', status)
  },

  setUploadFiles: function ({ commit }, file) {
    commit('FILE_SET_UPLOAD_FILES', file)
  },

  uploadFile: function ({ commit, dispatch }, data) {
    let analyticsStartTime = Moment(new Date())

    if (
      data.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
      data.file.type !== 'application/vnd.ms-excel'
    ) {
      dispatch('setuploadFileStatusMessage', 'Formato de arquivo inválido.')
      return
    }

    if (data.file.size === 0) {
      dispatch('setuploadFileStatusMessage', 'Erro no Upload do Arquivo.')
      return
    }

    commit('FILE_SET_UPLOAD_STATUS', 'STATUS_UPLOADING')
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'upload',
      action: 'inicio'
    })
    uploadService
      .sendFile(data.file, data.id, data.glucose, data.glycatedHemoglobin, data.collectDate)
      .then(response => {
        commit('FILE_SET_UPLOAD_STATUS', 'STATUS_SUCCESS')

        if (data.profile === 'DIAVERUM') {
          if (response.data.persisted) {
            let secondsToWait = response.data.persisted * 100
            dispatch('setStepperModalVisible', true)
            setTimeout(() => {
              window.location.href = '/patient-routine?filterBy=P'
            }, secondsToWait)
          } else {
            window.location.href = '/patient-routine?filterBy=P'
          }
        } else {
          router.push('/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL)
        }
        commit(OS_FILTER_SHOW_OFF, false)
        commit(FILE_SET_UPLOAD_SHOW_OFF, false)
        let ignoredOS = parseInt(response.headers['content-ignored-number'])
        let acceptedOS = parseInt(response.headers['content-accepted-number'])
        let fileToRemove = parseInt(response.headers['file-to-remove'])
        let duplicatedOrders = response.data.orderModel ? response.data.orderModel : response.data
        if (fileToRemove > 0) {
          uploadService.deleteFile(fileToRemove)
        }
        if (duplicatedOrders.length > 0) {
          commit(FILE_SET_DUPLICATED_ORDERS, duplicatedOrders)
          dispatch('setStepperModalVisible', true)
        } else {
          if (ignoredOS > 0) {
            notify({
              title: 'AVISO:',
              message:
                ignoredOS +
                (ignoredOS > 1
                  ? ' Ordens de Serviço duplicadas foram ignoradas.'
                  : ' Ordem de Serviço duplicada foi ignorada.')
            })
          }
        }

        if (acceptedOS > 0) {
          notify({
            title: 'AVISO:',
            message: 'OSˊs importadas estarão disponíveis em instantes.',
            action: {
              title: 'ATUALIZAR',
              handler: reload
            }
          })
        }
        if (acceptedOS > 0) {
          notify({
            title: 'AVISO:',
            message: 'Importação de ' + acceptedOS + ' OS(s) realizada(s) com sucesso.'
          })
        }

        analyticsFileForUploadTime({
          startTime: analyticsStartTime,
          fileSize: data.file.size,
          response: 'Sucesso'
        })
      })
      .catch(error => {
        const errorCode = JSON.stringify(error.response.data.code)
        if (errorCode === '"INVALID_COLLECTION_POINT"') {
          commit(FILE_SET_UPLOAD_SHOW_OFF, false)
          commit(FILE_SET_UPLOAD_MODAL_ERROR, true)
        }
        commit('FILE_SET_UPLOAD_STATUS', 'STATUS_FAILED')
        var payload = error.response.data
        commit(FILE_SET_UPLOAD_STATUS_MESSAGE, payload.description || payload.message)
        analyticsFileErrorXSD(payload.description || payload.message)
        analyticsFileForUploadTime({
          startTime: analyticsStartTime,
          fileSize: data.file.size,
          response: 'Falha'
        })
      })
  },
  setInitialUploadFileStatus: function ({ commit }) {
    commit('FILE_SET_UPLOAD_STATUS', 'STATUS_INITIAL')
  },
  setInitialMaintenanceFileStatus: function ({ commit }) {
    commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_INITIAL')
    commit(FILE_SET_UPLOAD_MAINTENANCE_MESSAGE, defaultErrorFile)
  },
  setuploadFileStatusMessage: function ({ commit }, message) {
    commit(FILE_SET_UPLOAD_STATUS_MESSAGE, message)
  },
  setUploadFileModalVisible: function ({ commit }, value) {
    commit(FILE_SET_UPLOAD_SHOW_OFF, value)
  },
  updateOsFile: function ({ commit, dispatch }, order) {
    commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_UPLOADING')
    if (order.state === 'T') {
      let examsIds = filterFileExamsWithError(order.exams)
      if (examsIds.length > 0) {
        return uploadService
          .deleteOrderDuplicated(order.idOrder, examsIds)
          .then(() => {
            dispatch('updateAfterTransmit', order)
          })
          .catch(error => {
            dispatch('updateAfterTransmit', order)
            analyticsFileForOrderMaintenance(error.response)
          })
      } else {
        dispatch('updateAfterTransmit', order)
      }
    } else {
      dispatch('updateBeforeTransmit', order)
    }
  },
  updateFileBeforeTransmit: function ({ commit }, order) {
    return uploadService
      .updateOrderDuplicatedBeforeTransfered(order.idOrder)
      .then(() => {
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
        notify({
          title: 'AVISO:',
          message: SUCESS_SAVED
        })
      })
      .catch(() => {
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_FAILED')
        notify({
          title: 'AVISO:',
          message: ERROR_SAVED
        })
      })
  },
  updateFileAfterTransmit: function ({ commit, rootState }, order) {
    return uploadService
      .updateOrderDuplicatedAfterTransfered(order)
      .then(() => {
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
        notify({
          title: 'AVISO:',
          message: SUCESS_SAVED
        })
      })
      .catch(error => {
        var payload = error.response.data
        let errorMsg = ''

        if (error.response.data.code === 'IRREGULAR_LABORATORY' || rootState.authentication.profile.defaulter) {
          errorMsg = 'Identificamos problemas de faturamento que estão restringindo o envio de suas amostras.'
        } else {
          errorMsg = payload.message
        }

        commit(FILE_SET_UPLOAD_MAINTENANCE_MESSAGE, errorMsg)
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_FAILED')
        analyticsFileForOrderMaintenance(errorMsg)
      })
  },
  deleteOsFile: function ({ commit }, order) {
    commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_UPLOADING')
    let examsIds = filterFileNewExams(order.exams)
    return uploadService
      .deleteOrderDuplicated(order.idOrder, examsIds)
      .then(() => {
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
      })
      .catch(() => {
        commit(FILE_SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
      })
  },
  clearFileDuplicatedOrdersArray: function ({ commit }) {
    commit(FILE_CLEAR_DUPLICATED_ORDERS)
  },
  getFiles: function ({ commit }, value) {
    commit(FILE_SET_FILES_SENT_STATUS, 'STATUS_SUCCESS')
    return uploadService
      .getFilesSent(value.startDate, value.endDate, value.idLaboratory, value.stateList)
      .then(response => {
        commit(FILE_SET_UPLOAD_FILES, response.data)
        commit(FILE_SET_FILES_SENT_STATUS, 'STATUS_END')
      })
      .catch(error => {
        notify({
          title: 'AVISO:',
          message: 'Houve um erro ao tentar carregar a lista de arquivos. Tente Novamente.'
        })
        var payload = error.response.data
        analyticsFileErrorXSD(payload.description || payload.message)
        commit(FILE_SET_FILES_SENT_STATUS, 'STATUS_END')
      })
  }
}

let defaultErrorFile = 'Não foi possível salvar esta operação.'

let filterFileExamsWithError = function (exams) {
  return exams.reduce(function (filteredExams, elem) {
    if (elem.added_file_exam && elem.status === 'E') {
      filteredExams.push(elem.id_exam_order)
    }
    return filteredExams
  }, [])
}

let filterFileNewExams = function (exams) {
  return exams.reduce(function (filteredExams, elem) {
    if (elem.added_file_exam) {
      filteredExams.push(elem.id_exam_order)
    }
    return filteredExams
  }, [])
}

let reload = function () {
  window.location.reload()
}

let analyticsFileErrorXSD = message => {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Importação de Arquivo',
    action: message
  })
}

let analyticsFileForOrderMaintenance = message => {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Importação de File',
    action: 'Manutencao de OS via File - ' + message
  })
}

let analyticsFileForUploadTime = ({ startTime, fileSize, response }) => {
  let endTime = Moment(new Date())
  let uploadTime = endTime.diff(startTime, 'seconds')

  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Importação de Arquivo',
      action: 'Tempo de Upload - ' + response,
      label: uploadTime,
      value: uploadTime,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName,
      'file-size': fileSize
    })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
